<template>
  <div id="app">
    <div
      v-show="$store.state.DLINE_ENVIRONMENT"
      id="devenvironment_warning"
      style="
        position: fixed;
        z-index: 10000;
        top: 0;
        width: 100px;
        margin-left: -50px;
        left: 50%;
        background-color: #ffb734;
        text-align: center;
        padding: 10px;
        border-radius: 0 0 4px 4px;
        opacity: 0.5;
        font-weight: bold;
        pointer-events: none;
      "
    >
      {{ $store.state.DLINE_ENVIRONMENT }}
    </div>
    <keep-alive>
      <!-- 需要缓存的视图组件 -->
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <!-- 不需要缓存的视图组件 -->
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
// import eruda from 'eruda'
export default {
  name: "App",
  data() {
    return {};
  },
  watch: {
    $route: {
      handler(to, from) {
        //console.log(to);
        //console.log(from);
        //console.log(this.$store.state.browser);
        if (
          this.$store.state.browser.ios &&
          this.$store.state.browser.giantapp
        ) {
          if ("scrollRestoration" in history) {
            history.scrollRestoration = "manual"; //改为manual之后，就不会记录滚动位置
          }
        }
      },
      immediate: true, //首次进入页面即执行
    },
  },
  mounted() {
    // eruda.init()
  },
  methods: {},
};
</script>

<style>
html,
body {
  height: 100%;
}

#app {
  background-color: #edf0f8;
}
</style>



// WEBPACK FOOTER //
// src/App.vue